import tw from "tailwind-styled-components"

export const H = tw.h1 `
   text-[#1B3781]
   mt-3  
   font-semibold
   text-base
   sm:text-lg
   lg:text-lg  
      
` 

export const P = tw.p `
   
   mt-1
   text-justify
   text-sm
   sm:text-base
`
